<div id='rr_back'>
    <div id='rr_icon'><div [inlineSVG]="'assets/images/sync.svg'"></div></div>
    <div id='rr_sync_bold'>{{trans('systems.labels.synchronize')}}</div>
    <div id='rr_system'>{{trans('systems.labels.system')}}: {{systems.activeSystem.name}}</div>
    <div id='rr_sync_button' class="button" (click)="reReadClick()">{{trans('systems.buttons.sync')}}</div>
</div>
<div id='rr_why'>{{trans('systems.labels.whySync')}}</div>
<div id='rr_why_desc'>{{trans('systems.labels.whySyncDescription')}}</div>